import { validate } from "com";
import { ADDRESS_ENDPOINTS } from "./endpoints";
import type { AutocompleteResponse } from "./types";
import { apiPostWithData } from "../shared/apiClient";
import { DEFAULT_API_OPTIONS, DEFAULT_COUNTRY_CODE, MIN_AUTOCOMPLETE_QUERY_LENGTH } from "./constants";

export default async function autocompleteAddress(
  query: string,
  country: string = DEFAULT_COUNTRY_CODE
): Promise<AutocompleteResponse["suggestions"]> {
  if (!query || typeof query !== "string" || query.trim().length < MIN_AUTOCOMPLETE_QUERY_LENGTH) {
    return [];
  }

  if (country) {
    validate.countryCode(country);
  }

  const response = await apiPostWithData<AutocompleteResponse>(
    ADDRESS_ENDPOINTS.AUTOCOMPLETE,
    { query, country },
    DEFAULT_API_OPTIONS
  );

  return response.suggestions ?? [];
}
